<template>
  <div class="commodity-contain">
    <p class="title">{{ target.title }}</p>
    <div class="user-info">
      <p>收件人: {{ userInfo.name }}</p>
      <p>收货地址: {{ userInfo.province }}/{{ userInfo.city }}/{{ userInfo.area }},{{ userInfo.detail }}</p>
      <p>tel: {{ userInfo.contact }}</p>
      <p>购买数量: {{ item.amount }}</p>
      <p v-if="item.note">备注: {{ item.note }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommodityContain',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    userInfo () {
      return this.item.address
    },
    target () {
      return this.item.target
    }
  }
}
</script>

<style scoped lang="scss">
.commodity-contain {
  .title {
    @include sc($font-size-lg, $color-text-heavy);
    @include lw(23px, 500);
  }
  .user-info {
    @include sc($font-size-md, $color-text-light);
    margin-top: 8px;
    > p {
      & + p {
        margin-top: 4px;
      }
    }
  }
}
</style>
